export { default } from "./CoveoSearchResult";
export { rehydrator } from "./CoveoSearchResult.rehydrator";